import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorPrestamosExternosItemComponent {
  resultados = {}
  idDescuento
  idProyecto

  abrir() {
    this.expandido = true;
  }

  cerrar() {
    this.expandido = false;
  }

  eliminar() {
    this.onDelete()
  }

}

module.component('colaboradorPrestamosExternosItem', {
  controller: ColaboradorPrestamosExternosItemComponent,
  template,
  bindings: {
    resultados: '<',
    descuentoId: '<',
    idProyecto: '<',
    onDelete: '&',
  },
})


// WEBPACK FOOTER //
// ./src/colaborador/components/prestamosExternos/item/component.js